import { render, staticRenderFns } from "./FormSeparator.vue?vue&type=template&id=c8f0b850&scoped=true&"
import script from "./FormSeparator.vue?vue&type=script&lang=ts&"
export * from "./FormSeparator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f0b850",
  null
  
)

export default component.exports